import { ITableFilterComponentProps } from "@/interfaces/Table";
import { ChangeEvent, FC } from "react";
import { Card, Form } from "react-bootstrap";

const UserFilters: FC<ITableFilterComponentProps> = ({
  filters,
  onFiltersChange,
}) => {
  const handleStateChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;

    onFiltersChange({
      isActive: value === "" ? undefined : value === "true",
    });
  };

  return (
    <Card className="shadow-none shadow-show-xl scrollbar h-100">
      <Card.Body>
        <Form.Group>
          <Form.Label htmlFor="user-state-filter" className="mb-1 fs--1">
            État
          </Form.Label>
          <Form.Select
            id="user-state-filter"
            value={
              filters.isActive === undefined
                ? ""
                : filters.isActive.toString()
            }
            onChange={handleStateChange}
          >
            <option value="">Tous</option>
            <option value="true">Actifs</option>
            <option value="false">Inactifs</option>
          </Form.Select>
        </Form.Group>
      </Card.Body>
    </Card>
  );
};

export default UserFilters;
